
import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, TextField, Button, Box, Grid, Typography } from '@mui/material';
import { formatInputWithCommas } from '../../utils/PriceFormatter';

function AddEarmarkDialogInput({ open, onClose, dealerName, onSubmit }) {
  const [formData, setFormData] = useState({
    dealer: '',
    earmark: '',
    reason: '',
   
  });
  const [errors, setErrors] = useState({});

  // auto update dealer name in the form
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      dealer: dealerName,
      earmark: '',
      reason: '',
    }));
  }, [open]);

  const handleClose = () => {
    setFormData({
      dealer: '',
      earmark: '',
      reason: '',
    });
    onClose();
  };

  const handleInputChange = (e) => {
    const {  name, value } = e.target;
    const sanitizedValue = value.replace(/,/g, '');
    setFormData({ ...formData, [name]: sanitizedValue });
    setErrors({ ...errors, [name]: '' });
  };


 const handleSubmit = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};
    if (!formData.dealer.trim()) {
      newErrors.dealer = 'Dealer Name is required';
    }

    if (!formData.earmark.trim()) {
      newErrors.earmark = 'Earmark is required';
    } else {
      let formattedEarmark = formData.earmark.trim();

      if (formattedEarmark <= 0){
        newErrors.earmark = 'Earmark amount must be greater than 0.00';
      } else {
        const isValid = /^[\d,]+(\.\d{1,2})?$/.test(formattedEarmark.replace(/,/g, ''));
        if (!isValid) {
          newErrors.earmark = 'Earmark must be a number with up to 2 decimal places';
        }
      }
    }

    if (!formData.reason.trim()) {
        newErrors.reason = 'Reason is required';
      }

    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data
      onSubmit(formData);

       // Close the dialog
      onClose();
      // You can perform additional actions like sending data to a server here
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
     
      <DialogContent>
      <Box>
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            item
        >
            <Typography fontWeight={'600'} variant="h3" p={1}>
              Add Earmark
            </Typography>
        </Grid>
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            item
        >
            <Typography
                fontSize={'16px'}
                fontWeight={'400'}
                pb={4}
            >
                Please specify Earmark for the dealer
            </Typography>
        </Grid>
      </Box>
        <form onSubmit={handleSubmit}>
          <TextField
            autoFocus
            margin="dense"
            label="Dealer"
            type="text"
            name="dealer"
            fullWidth
            value={formData.dealer}
            onChange={handleInputChange}
            error={Boolean(errors.dealer)}
            helperText={errors.dealer}
            InputProps={{
              readOnly: Boolean(dealerName),
            }}
          />
          <TextField
            margin="dense"
            label="Earmark"
            type="text"
            name="earmark"
            fullWidth
            value={formatInputWithCommas(formData.earmark)}
            onChange={handleInputChange}
            error={Boolean(errors.earmark)}
            helperText={errors.earmark}
          />
           <TextField
            margin="dense"
            label="Reason"
            type="text"
            name="reason"
            fullWidth
            value={formData.reason}
            onChange={handleInputChange}
            error={Boolean(errors.reason)}
            helperText={errors.reason}
          />
          {/* Add more fields as needed */}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button  variant="contained" type="submit" onClick={handleSubmit} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>




  );
}

export default AddEarmarkDialogInput;
